import { createAsyncTypes } from 'utils/ActionCreator'

const typeKey = 'AwarenessCenter/WizardCampaignEdit'

export const GET_CAMPAIGN_ASYNC = createAsyncTypes('GET_CAMPAIGN', typeKey)
export const INIT_EDIT_MODE = `${typeKey}/INIT_EDIT_MODE`
